

























































































import { defineComponent, ref, PropType, computed, useRoute, useContext } from '@nuxtjs/composition-api';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppFavoriteIconButton from '~/components/partials/App/AppFavoriteIconButton.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import ContentRelatedItemImage from '~/components/partials/Content/ContentRelatedItemImage.vue';
import ContentReview from '~/components/partials/Content/ContentReview.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { useStore } from '~/composables/useStore';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import { PRODUCT_CART_BUTTON } from '~/constants';
import { url, nonNullable, isInsidePeriod } from '~/utils';
import { getLotteryInfoFromSearch } from '~/utils/checkLotteryStatus';
import { ProductListItem } from '~/types/modules/product';
import { ProductCategoryText, ProductSetType, DisplayLang, FavoriteTypes } from '~/enums';

export default defineComponent({
  components: {
    ProductCartButton,
    AppPrice,
    AppLink,
    AppRectButton,
    ContentRelatedItemImage,
    ContentReview,
    ProductLabel,
    ProductWineColorLabel,
    ProducingAreaFlag,
    AppFavoriteIconButton,
  },
  props: {
    isCart: {
      type: Boolean,
      default: false,
    },
    hasProducerName: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object as PropType<ProductListItem>,
      required: true,
    },
  },
  setup(props) {
    const isWine = [
      ProductCategoryText.WINE,
      ProductCategoryText.OTHER_ALCOHOL,
      ProductCategoryText.NON_ALCOHOL,
    ].includes(props.item.category);
    const isVintageModalOpen = ref(false);
    const store = useStore();
    const { checkIsFavorite } = useListFavorite();
    const isFavorite = computed(() => checkIsFavorite(props.item.code, FavoriteTypes.ITEM));
    const { currentLang } = useWOVNio();
    const route = useRoute();
    const { i18n } = useContext();

    const producingArea = computed(() => {
      const { producing_area } = props.item;

      return {
        code_id: producing_area.area_id_1 || '',
        areas: [
          {
            name: producing_area.area_1,
            id: producing_area.area_id_1,
          },
          {
            name: producing_area.area_2,
            id: producing_area.area_id_2,
          },
          {
            name: producing_area.area_3,
            id: producing_area.area_id_3,
          },
        ],
      };
    });

    const producerLink = computed(() => {
      return url('PRODUCER_DETAIL', { id: props.item.producer_id });
    });

    // 言語環境に応じて、商品情報を出し分ける
    const productInfo = computed(() => {
      if (currentLang.value.code === DisplayLang.JA) {
        return {
          productName: props.item.name,
          producerName: props.item.producer,
        };
      }
      return {
        productName: props.item.name_en,
        producerName: props.item.producer_name_en,
      };
    });

    // よりどり商品かどうか
    const isFlexibleSetItem = computed(() => {
      return props.item.set_type === ProductSetType.FLEXIBLE_SET;
    });

    const productDetailUrl = computed(() =>
      isDistributionItem.value
        ? url('ITEM_DISTRIBUTION_DETAIL', { code: props.item.code })
        : url('ITEM_DETAIL', { code: props.item.code })
    );

    // 頒布会商品かどうか
    const isDistributionItem = computed(() => {
      return props.item.product_type === i18n.t('Common.productListItem.text.productType').toString();
    });

    // 商品詳細リンクを設定するか
    const isUnsetItemDetailLink = computed(() => {
      // カートページかつ、親商品非表示設定かつ、頒布会商品であるか判定
      const isDisplay = !!props.item.product_display_flag;
      return !isDisplay && route.value.path === url('CART') && !isDistributionItem.value;
    });

    const isVisaMember = computed(() => store.getters['user/info/isVisaMember']);

    const labels = computed(() => {
      const { sale_label, is_limited_stock, is_visa_happy_wine } = props.item;
      return (
        [
          isVisaMember.value && is_visa_happy_wine
            ? { color: 'Sale', text: i18n.t('Common.productListItem.text.visaHappyWine').toString() }
            : null,
          is_limited_stock
            ? { outline: 'Gray', text: i18n.t('Common.productListItem.text.limitedStock').toString() }
            : null,
          sale_label ? { color: 'Sale', text: sale_label } : null,
        ].filter(nonNullable) || []
      );
    });

    const isNowOnSale = computed(() => {
      return isInsidePeriod(props.item.sale_start, props.item.sale_end);
    });

    return {
      producingArea,
      ProductCategoryText,
      productDetailUrl,
      isWine,
      isVintageModalOpen,
      isFavorite,
      producerLink,
      isFlexibleSetItem,
      isDistributionItem,
      productInfo,
      PRODUCT_CART_BUTTON,
      getLotteryInfoFromSearch,
      isUnsetItemDetailLink,
      labels,
      isNowOnSale,
    };
  },
});
